import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GuidanceDrawerComponent } from './guidance-drawer/guidance-drawer.component';
import { GuidanceComponent } from './guidance/guidance.component';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DrawerModule } from 'primeng/drawer';

@NgModule({
    declarations: [GuidanceDrawerComponent, GuidanceComponent],
    imports: [CommonModule, MatIconModule, MatTooltipModule, DrawerModule],
    exports: [GuidanceDrawerComponent, GuidanceComponent],
})
export class GuidanceModule {}
